/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TeamModelListResult } from '../../models/team-model-list-result';

export interface ApiTeamTeamsGet$Xml$Params {
  ConferenceIds?: Array<number>;
}

export function apiTeamTeamsGet$Xml(http: HttpClient, rootUrl: string, params?: ApiTeamTeamsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamModelListResult>> {
  const rb = new RequestBuilder(rootUrl, apiTeamTeamsGet$Xml.PATH, 'get');
  if (params) {
    rb.query('ConferenceIds', params.ConferenceIds, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TeamModelListResult>;
    })
  );
}

apiTeamTeamsGet$Xml.PATH = '/api/team/teams';
